import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from "./Button";
import Label from "./Label";
import Configuration from "../../Configuration";

/**
 * Class representing an incremental input.
 *
 * This component is composed of 2 button : one to increment the value and another one to decrease it.
 *
 * The value is displayed between the buttons.
 */
class IncrementalInput extends React.Component {
    static propTypes = {
        className: PropTypes.string,

        // The input label, displayed on top of the input
        label: PropTypes.string,

        // The input value
        value: PropTypes.number,

        // How much the value can be incremented/decreased
        step: PropTypes.number,

        // Min input value
        min: PropTypes.number,

        // Max input value
        max: PropTypes.number,

        // Allow to add a symbol next to the value
        symbol: PropTypes.string,

        // Define if add two rows
        rowTwo: PropTypes.number,

        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        value: 0,
        step: 5,
        min: 0,
        max: 100,
        rowTwo: 0,
        disabled: false
    };

    state = {
        value: this.props.value ? this.props.value : this.props.min
    };

    /**
     * On mount if no value has been provided but a min has,
     * calling the onChange handler with min as parameter.
     */
    componentDidMount() {
        const {min, value, onChange} = this.props;

        if (!value && min) {
            onChange(min);
        }
    }

    /**
     * Triggered when the value change.
     *
     * @param direction Define if the value is increased or decreased.
     *
     * @returns {Function}
     */
    onChange = direction => () => {
        const {max, min} = this.props;
        const value = this.state.value + this.props.step * direction;

        if (
            (direction > 0 && value > max) ||
            (direction < 0 && value < min)
        ) {
            return;
        }

        this.setState({value});

        this.props.onChange && this.props.onChange(value);
    };

    render() {
        const {value} = this.state;
        const {className, label, min, max, symbol, rowTwo, disabled} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap":"");
        const classes = classNames(
            "cccu-incremental-input",
            "cccu-inc-digital-one",
            "d-flex",
            client,
            {
                [className]: className !== undefined,
                disabled: disabled
            }
        );

        let classesLabel = (rowTwo === 1) ? "label-height d-flex align-items-center justify-content-center" : "d-flex justify-content-center";

        return (
            <React.Fragment>
                <Label className={classesLabel}>{label}</Label>

                <div className={classes}>
                    <Button className={"cccu-inc-btn"} onClick={this.onChange(-1)} disabled={value === min}>-</Button>
                    <span className="text-center input-increment input-digital-one">{value} {symbol && ` ${symbol}`}</span>
                    <Button className={"cccu-inc-btn"} onClick={this.onChange(1)} disabled={value === max}>+</Button>
                </div>
            </React.Fragment>
        )
    }
}

export default IncrementalInput;


// WEBPACK FOOTER //
// ./src/components/widgets/IncrementalInput.js